import {Outlet} from 'react-router-dom';
// @mui
import {styled} from '@mui/material/styles';
//
import NavigationBar from '../../components/NavigationBar';
import CookiesBanner from "../../utils/CookiesBanner";
import Footer from "./footer";

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 72;

const StyledRoot = styled('div')({
    display: 'flex', flexDirection: 'column', minHeight: '100%', overflow: 'hidden', background: "rgb(249, 250, 251)"
});

const Main = styled('div')(({theme}) => ({
    overflow: 'auto', flexGrow: 1, minHeight: '100%', paddingTop: APP_BAR_MOBILE, paddingBottom: theme.spacing(5),

    [theme.breakpoints.up('md')]: {
        paddingTop: APP_BAR_DESKTOP,
    },
}));

// ----------------------------------------------------------------------

export default function BodyLayout() {
    return (<StyledRoot>
            <NavigationBar/>
            <CookiesBanner/>
            <Main id="main-scroll">
                <Outlet/>
                <Footer/>
            </Main>
        </StyledRoot>);
}
